import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../idealBodyWeightAction';
import fetchApi from "./fetchApi";

function fetchIdealBodyWeightAction() {
  return fetchApi('/v1/fc_api/ideal_body_weight_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchIdealBodyWeightAction;
